import { defineMessages } from 'react-intl';

export const customerReviewTermsMessages = defineMessages({
  dialogHeadline: {
    defaultMessage: 'Nutzungsbedingungen',
    id: 'customerReviews.addReview.customerReviewTerms.dialogHeadline',
  },
  label: {
    defaultMessage:
      'Ich habe die <link>Nutzungsbedingungen</link> gelesen und erkläre mich damit einverstanden.*',
    id: 'customerReviews.addReview.customerReviewTerms.label',
  },
  error: {
    defaultMessage: 'Bitte akzeptiere unsere Nutzungsbedingungen.',
    id: 'customerReviews.addReview.customerReviewTerms.error',
  },
});
